import type { SVGProps } from "react"

const Vehicle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 350" {...props}>
    <circle data-name="Ellipse 3549" cx={175} cy={175} r={175} fill="#fff" />
    <path
      data-name="Path 28827"
      d="M46.1 244.859a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28828"
      d="M46.174 258.249a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28829"
      d="M57.694 251.554a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.18 3.18 0 002.89 0 .883.883 0 00-.01-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28830"
      d="M57.77 264.943a3.186 3.186 0 00-2.89 0 .885.885 0 00.01 1.674 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28831"
      d="M69.29 258.248a3.181 3.181 0 00-2.889 0 .884.884 0 00.009 1.673 3.18 3.18 0 002.89 0 .885.885 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28832"
      d="M69.366 271.638a3.186 3.186 0 00-2.89 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28833"
      d="M80.886 264.943a3.186 3.186 0 00-2.89 0 .885.885 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28834"
      d="M80.961 278.333a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28835"
      d="M92.557 285.028a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28836"
      d="M92.482 271.638a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28837"
      d="M104.077 278.333a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28838"
      d="M104.153 291.723a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28839"
      d="M115.673 285.028a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28840"
      d="M115.748 298.417a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28841"
      d="M127.269 291.722a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28842"
      d="M127.344 305.112a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28843"
      d="M138.864 298.417a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28844"
      d="M138.789 285.027a3.181 3.181 0 00-2.889 0 .884.884 0 00.009 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28845"
      d="M150.385 291.722a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28846"
      d="M196.466 264.943a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28847"
      d="M196.391 251.553a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28848"
      d="M207.986 258.248a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28849"
      d="M207.911 244.858a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28850"
      d="M219.507 251.553a3.183 3.183 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28851"
      d="M219.431 238.163a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28852"
      d="M231.027 244.858a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28853"
      d="M150.46 305.112a3.181 3.181 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28854"
      d="M161.98 298.417a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28855"
      d="M173.576 305.112a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .885.885 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28856"
      d="M173.5 291.722a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28857"
      d="M185.1 298.417a3.181 3.181 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28858"
      d="M185.021 285.027a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .885.885 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28859"
      d="M196.617 291.722a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28860"
      d="M196.541 278.332a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28861"
      d="M208.137 285.027a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28862"
      d="M208.062 271.638a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28863"
      d="M219.657 278.332a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.183 3.183 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28864"
      d="M219.582 264.943a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28865"
      d="M231.178 271.637a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28866"
      d="M231.1 258.248a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28867"
      d="M242.7 264.943a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28868"
      d="M242.623 251.553a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28869"
      d="M254.218 258.248a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28870"
      d="M230.952 231.468a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28871"
      d="M242.472 224.773a3.181 3.181 0 00-2.889 0 .884.884 0 00.009 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28872"
      d="M242.547 238.163a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28873"
      d="M254.068 231.468a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28874"
      d="M253.992 218.079a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28875"
      d="M265.588 224.773a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28876"
      d="M300.074 191.3a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28877"
      d="M300.149 204.689a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28878"
      d="M311.669 197.994a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28879"
      d="M311.594 184.6a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28880"
      d="M323.19 191.3a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28881"
      d="M254.143 244.858a3.181 3.181 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28882"
      d="M265.739 251.553a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28883"
      d="M265.663 238.163a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28884"
      d="M277.259 244.858a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .885.885 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28885"
      d="M277.184 231.468a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28886"
      d="M288.779 238.163a3.181 3.181 0 00-2.889 0 .884.884 0 00.009 1.674 3.186 3.186 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28887"
      d="M288.7 224.773a3.186 3.186 0 00-2.89 0 .885.885 0 00.01 1.674 3.181 3.181 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28888"
      d="M300.3 231.468a3.186 3.186 0 00-2.89 0 .884.884 0 00.01 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28889"
      d="M300.224 218.078a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28890"
      d="M311.82 224.773a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.184 3.184 0 002.889 0 .884.884 0 00-.009-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28891"
      d="M311.745 211.384a3.18 3.18 0 00-2.89 0 .884.884 0 00.01 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28892"
      d="M323.34 218.078a3.184 3.184 0 00-2.889 0 .884.884 0 00.009 1.674 3.18 3.18 0 002.89 0 .884.884 0 00-.01-1.674"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28893"
      d="M323.265 204.689a3.178 3.178 0 00-2.889 0 .884.884 0 00.009 1.673 3.178 3.178 0 002.889 0 .884.884 0 00-.009-1.673"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28894"
      d="M305.8 128.609l-20.283-17.8-76.2 43.99-23.637 48.968a.544.544 0 01-.169.3l-45.971 38.74a18.682 18.682 0 00-6.223 10.449.515.515 0 01-.036.109 18.616 18.616 0 00-.359 3.594v23.69c.828.089 3.4.122 7.268-2.11l8.533-4.924v-.5c0-11.6 8.174-25.769 18.222-31.578 4.965-2.865 9.659-3.311 13.216-1.256s5.5 6.309 5.515 12.008l70.741-40.849a13.799 13.799 0 01-.011-.5c0-11.607 8.183-25.773 18.241-31.578 4.959-2.866 9.649-3.314 13.2-1.262 3.5 2.02 5.457 6.2 5.519 11.8l8.7-7.252a26.2 26.2 0 009.452-20.181v-20.4a18.8 18.8 0 00-5.723-13.463z"
      fill="currentColor"
    />
    <path
      data-name="Path 28895"
      d="M284.583 110.2l-63.741-36.8a42.745 42.745 0 00-38.442-2.1l-64.957 31.993 91.491 50.586z"
      fill="currentColor"
    />
    <path
      data-name="Path 28896"
      d="M138.852 242.045l45.448-38.294-51.746-29.877-41.08-23.719-46.919 39.523a15.136 15.136 0 00-5.285 9.7l93.176 53.009a19.679 19.679 0 016.406-10.342z"
      fill="currentColor"
    />
    <path
      data-name="Path 28897"
      d="M39.141 201.314v21.434a11.166 11.166 0 005.568 9.643l79.915 46.146a15.571 15.571 0 007.256 2.077v-23.581a19.564 19.564 0 01.343-3.623l-93.056-52.941q-.026.431-.026.845z"
      fill="currentColor"
    />
    <path
      data-name="Path 28898"
      d="M184.959 202.98l4.874-10.1 18.452-38.23-91.719-50.711-17.283 32.068-7.2 13.349zm-68.1-95.445a.5.5 0 01.692-.2l1.953 1.132 85.124 46.868a.5.5 0 01.208.653l-19.871 41.049-1.079 2.246a.5.5 0 01-.3.26.523.523 0 01-.147.022.5.5 0 01-.249-.067l-87.432-50.584a.5.5 0 01-.193-.662z"
      fill="currentColor"
    />
    <path
      data-name="Path 28899"
      d="M91.377 148.579l6.87-12.747-3.805-4.6a4.346 4.346 0 00-3.013-1.549 4.111 4.111 0 00-.35-.014 4.349 4.349 0 00-2.871 1.077l-.774.674a7.1 7.1 0 00-1.2 9.354z"
      fill="currentColor"
    />
    <path
      data-name="Path 28900"
      d="M194.806 191.858l-.373.329a6.906 6.906 0 00-2.088 3.325l-.5 1.794a.49.49 0 01-.6.35.766.766 0 00-.185-.021 1.312 1.312 0 00-1.125.983 1.223 1.223 0 00.538 1.578l18.42 5.7a5.137 5.137 0 006.413-3.383l.212-.687a7.416 7.416 0 00-4.893-9.275l-7.8-2.412a8.439 8.439 0 00-8.019 1.719z"
      fill="currentColor"
    />
    <path
      data-name="Path 28901"
      d="M292.192 187.508c-.035-.28-.067-.564-.113-.834a16.98 16.98 0 00-.217-1c-.043-.18-.083-.363-.132-.537-.1-.345-.206-.675-.324-1-.051-.142-.1-.284-.157-.421q-.192-.478-.416-.922c-.066-.131-.135-.259-.2-.385a10.634 10.634 0 00-.486-.8c-.092-.136-.192-.264-.29-.394a8.946 8.946 0 00-.523-.644c-.134-.148-.28-.28-.423-.417-.171-.163-.339-.332-.521-.48a8.215 8.215 0 00-.92-.64c-.1-.061-.2-.114-.307-.17a8.1 8.1 0 00-.89-.417c-.082-.032-.16-.072-.243-.1a8.471 8.471 0 00-1.079-.3 9.598 9.598 0 00-2.069-.206 11.675 11.675 0 00-1.384.086l-.1.018 4.745 2.743c.052.029.11.047.162.077.208.12.394.272.59.409.105.073.213.14.315.218a8.718 8.718 0 01.675.588c.083.08.167.157.248.241a9.022 9.022 0 01.638.734c.052.066.1.135.152.2a10 10 0 01.6.9l.062.114a13.386 13.386 0 011.518 4.671c.03.2.071.388.094.592l1.184.688c0-.616-.029-1.211-.077-1.789-.033-.276-.076-.547-.112-.823z"
      fill="#fff"
    />
    <path
      data-name="Path 28902"
      d="M184.5 249.728c-.036-.287-.069-.576-.116-.853a17.609 17.609 0 00-.208-.974c-.044-.184-.085-.369-.134-.547-.094-.338-.2-.665-.313-.984-.051-.141-.1-.282-.157-.419q-.189-.477-.407-.922c-.064-.127-.132-.25-.2-.373a10.56 10.56 0 00-.481-.811c-.089-.132-.186-.254-.28-.38-.169-.228-.337-.456-.522-.663-.139-.154-.292-.29-.441-.433s-.318-.326-.491-.469a8.171 8.171 0 00-.934-.652c-.1-.06-.2-.121-.3-.177a8.189 8.189 0 00-1-.469c-.123-.047-.249-.086-.374-.127a8.54 8.54 0 00-.812-.225q-.3-.067-.6-.116-.4-.063-.823-.092a10.696 10.696 0 00-1.628.011l4.515 2.609c2.841 1.592 4.615 4.827 5 9.127l.865.5c0-.608-.028-1.2-.075-1.769-.009-.268-.05-.527-.084-.792z"
      fill="#fff"
    />
    <path data-name="Path 28903" d="M301 134.461a.479.479 0 01-.185.206L251 163.423v1.682l51.18-29.552z" fill="#fff" />
    <path
      data-name="Path 28904"
      d="M183.872 197.02L98.8 147.78a.5.5 0 01-.191-.662l19.991-38.029-1.09-.632-20.841 39.834 86.555 50.077z"
      fill="#fff"
    />
    <path
      data-name="Path 28905"
      d="M121.747 257.482l-13.489-7.782a2.122 2.122 0 00-2.164-.215 3.169 3.169 0 00-1.157 2.858c0 2.832 1.713 6.125 3.819 7.341l13.488 7.787a2.12 2.12 0 002.164.215 3.169 3.169 0 001.157-2.858c0-2.837-1.713-6.128-3.818-7.346z"
      fill="#fff"
    />
    <path
      data-name="Path 28906"
      d="M61.379 222.8l-13.489-7.787a2.781 2.781 0 00-1.364-.423 1.575 1.575 0 00-.8.209 3.171 3.171 0 00-1.156 2.858c0 2.833 1.713 6.125 3.819 7.34l13.488 7.788a2.124 2.124 0 002.163.215 3.169 3.169 0 001.157-2.858c.003-2.832-1.713-6.125-3.818-7.342z"
      fill="#fff"
    />
    <path
      data-name="Path 28907"
      d="M243.177 175.575a.579.579 0 00-.3-.078 1.253 1.253 0 00-.6.19l-8.576 4.951a4.636 4.636 0 00-1.882 3.642 1.464 1.464 0 00.488 1.292.924.924 0 00.9-.112l8.577-4.951a4.636 4.636 0 001.882-3.642 1.466 1.466 0 00-.489-1.292z"
      fill="#fff"
    />
    <path
      data-name="Path 28908"
      d="M302.1 142.844a.586.586 0 00-.3-.077 1.259 1.259 0 00-.6.189l-8.577 4.952a4.632 4.632 0 00-1.882 3.641 1.468 1.468 0 00.487 1.293.93.93 0 00.9-.112l8.577-4.952a4.635 4.635 0 001.882-3.642 1.466 1.466 0 00-.487-1.292z"
      fill="#fff"
    />
    <path
      data-name="Path 28909"
      d="M242.367 140.242l-1.442.836v27.887a.5.5 0 01-.249.431l-35.426 20.447 1.885.583 35.232-20.348z"
      fill="#fff"
    />
    <path
      data-name="Path 28910"
      d="M311.484 149.48l-.266.153c-2.008 1.159-3.7 5.111-3.686 8.63.006 2.047.587 3.651 1.517 4.186a1.636 1.636 0 001.709-.12l.761-.439z"
      fill="#fff"
    />
    <path
      data-name="Path 28911"
      d="M285.8 181.632c-.016-.009-.033-.015-.049-.024a.317.317 0 01-.052-.017 7.315 7.315 0 00-1.085-.494c-.042-.015-.084-.027-.126-.041a7.781 7.781 0 00-1.016-.271 7.347 7.347 0 00-.214-.039 8.4 8.4 0 00-1.076-.111c-.05 0-.1-.008-.15-.009a9.922 9.922 0 00-1.3.054h-.014a12.808 12.808 0 00-2.826.663l-.067.023c-.467.166-.941.362-1.419.583l-.149.071c-.476.225-.956.473-1.441.752-6.615 3.813-12.3 11.754-14.736 19.784a27.537 27.537 0 00-1.259 7.911c0 .587.025 1.154.072 1.7.027.308.076.6.117.892.031.227.053.462.092.681.066.363.155.7.244 1.045.034.133.061.275.1.4.105.357.231.693.362 1.023.039.1.071.205.112.3a10.1 10.1 0 00.459.919c.05.091.094.188.146.277a8.988 8.988 0 00.532.776c.069.093.134.192.206.281a7.975 7.975 0 00.58.622c.1.095.189.2.289.285a7.4 7.4 0 00.611.475c.194.139.379.289.587.409 2.907 1.681 6.81 1.276 10.989-1.133 8.828-5.1 16.009-17.531 16.009-27.708-.008-4.811-1.614-8.399-4.528-10.079zm-10.991 33.21a10.944 10.944 0 01-5.393 1.646 6.416 6.416 0 01-3.25-.838c-2.34-1.35-3.628-4.154-3.628-7.9 0-7.491 5.282-16.639 11.773-20.392 3.239-1.871 6.313-2.16 8.655-.807s3.624 4.149 3.624 7.885c0 7.5-5.285 16.648-11.781 20.406z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28912"
      d="M182.838 252.13a14.666 14.666 0 00-.878-4.114l-.014-.037a10.745 10.745 0 00-.5-1.1l-.041-.077a9.363 9.363 0 00-.576-.943c-.031-.044-.063-.085-.094-.128a8.243 8.243 0 00-.631-.774c-.057-.061-.12-.117-.179-.176a7.506 7.506 0 00-.66-.6c-.088-.069-.184-.126-.275-.192a7.208 7.208 0 00-.688-.458 7.342 7.342 0 00-1.057-.481c-.069-.025-.14-.046-.21-.069a7.679 7.679 0 00-.934-.249 7.967 7.967 0 00-.269-.05 8.514 8.514 0 00-1.008-.1c-.071 0-.141-.011-.213-.013a10.036 10.036 0 00-1.264.051l-.064.008a12.808 12.808 0 00-2.77.647c-.039.013-.077.025-.115.039q-.687.244-1.39.569l-.177.084a20.62 20.62 0 00-1.429.744c-6.064 3.506-11.35 10.478-14.062 17.8a33.589 33.589 0 00-1.213 4.011 26.086 26.086 0 00-.72 5.9c0 .586.026 1.153.073 1.7.025.294.073.57.111.853.033.241.056.489.1.722.063.345.148.67.232 1 .039.15.069.308.111.453.1.341.222.66.346.977.045.114.082.236.13.348a9.627 9.627 0 00.44.88c.057.1.107.213.167.313a8.8 8.8 0 00.516.751c.075.1.144.207.222.3a7.941 7.941 0 00.573.612c.1.1.192.2.294.289a7.367 7.367 0 00.621.482c.191.135.372.283.576.4 2.91 1.68 6.809 1.276 10.986-1.136 8.823-5.088 16-17.518 16-27.708 0-.521-.027-1.02-.064-1.511zM167.4 276.769a10.949 10.949 0 01-5.4 1.652 6.4 6.4 0 01-3.237-.834c-2.339-1.347-3.627-4.152-3.627-7.9 0-7.5 5.278-16.645 11.767-20.391 3.245-1.872 6.322-2.158 8.66-.807s3.624 4.152 3.624 7.892c.003 7.504-5.287 16.648-11.787 20.388z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28913"
      d="M284.269 119.79a4.569 4.569 0 00-5.42-.611L251 135.266v27.007l48.736-28.131z"
      fill="#1d1d1b"
    />
    <path data-name="Path 28914" d="M119.462 109.579l-19.751 37.579L184.3 196.12l19.432-40.141z" fill="#1d1d1b" />
    <path
      data-name="Path 28915"
      d="M209.878 161.188l-13.724 28.574c.074-.036.152-.061.227-.1.254-.12.512-.231.776-.326.077-.028.156-.052.234-.078q.418-.14.847-.238c.081-.019.162-.039.244-.056a9.366 9.366 0 012.12-.186c.14 0 .279.015.419.024q.3.023.606.064c.171.023.342.047.513.079.149.03.3.07.445.107.179.044.361.073.538.128l.83.257 35.976-20.765v-27.018l-25.7 14.841a10.784 10.784 0 00-4.351 4.693z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28916"
      d="M282.468 187.417a5.447 5.447 0 00-2.759-.7 9.99 9.99 0 00-4.9 1.513c-6.217 3.594-11.275 12.354-11.275 19.529 0 3.371 1.111 5.869 3.13 7.033s4.732.878 7.647-.807c6.222-3.6 11.283-12.365 11.283-19.54 0-3.37-1.111-5.864-3.126-7.028z"
      fill="#fff"
    />
    <path
      data-name="Path 28917"
      d="M175.068 249.354a5.454 5.454 0 00-2.761-.705 10 10 0 00-4.9 1.512c-6.214 3.588-11.269 12.349-11.269 19.529 0 3.374 1.111 5.872 3.128 7.034s4.727.871 7.642-.818c6.226-3.581 11.289-12.339 11.289-19.522-.003-3.369-1.113-5.866-3.129-7.03z"
      fill="#fff"
    />
    <path data-name="Path 28918" d="M152.646 128.088l-33.777 30.182 5.131 2.97 34.741-29.795z" fill="#fff" />
    <path data-name="Path 28919" d="M162.462 133.476l-35.891 29.218 1.065.611 37.245-28.505z" fill="#fff" />
    <path data-name="Path 28920" d="M114.328 155.592l1.486.869 25-22.029z" fill="#fff" />
    <path
      data-name="Path 28921"
      d="M282.966 186.555c-2.342-1.353-5.416-1.064-8.655.807-6.491 3.753-11.773 12.9-11.773 20.392 0 3.742 1.288 6.546 3.628 7.9a6.416 6.416 0 003.25.838 10.944 10.944 0 005.393-1.646c6.5-3.758 11.781-12.91 11.781-20.4 0-3.746-1.29-6.546-3.624-7.891zm-8.655 27.425c-2.915 1.685-5.632 1.971-7.647.807s-3.13-3.662-3.13-7.033c0-7.175 5.058-15.935 11.275-19.529a9.99 9.99 0 014.9-1.513 5.447 5.447 0 012.759.705c2.015 1.164 3.126 3.658 3.126 7.023 0 7.175-5.061 15.94-11.283 19.54z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28922"
      d="M175.566 248.492c-2.338-1.351-5.415-1.065-8.66.807-6.489 3.746-11.767 12.894-11.767 20.391 0 3.745 1.288 6.55 3.627 7.9a6.4 6.4 0 003.237.834 10.949 10.949 0 005.4-1.652c6.5-3.74 11.787-12.884 11.787-20.385 0-3.743-1.29-6.546-3.624-7.895zm-8.666 27.414c-2.915 1.689-5.628 1.977-7.642.818s-3.128-3.66-3.128-7.034c0-7.18 5.055-15.941 11.269-19.529a10 10 0 014.9-1.512 5.454 5.454 0 012.761.705c2.016 1.164 3.126 3.661 3.126 7.03.008 7.183-5.055 15.941-11.286 19.522z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28923"
      d="M303.506 135.7a.5.5 0 00-.156-.421l-18.05-16.745a5.146 5.146 0 00-6.133-.675l-.623.364c-.065.034-.133.057-.2.093l-28.1 16.231a.5.5 0 00-.249.432v30.988a.5.5 0 00.747.431l52.511-30.32a.5.5 0 00.253-.378zM251 135.266l27.851-16.087a4.569 4.569 0 015.42.611l15.465 14.352L251 162.273zm0 29.839v-1.682l49.818-28.756a.479.479 0 00.185-.206l1.177 1.092z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28924"
      d="M184.969 197.037l19.871-41.049a.5.5 0 00-.208-.653l-85.124-46.868-1.953-1.132a.5.5 0 00-.692.2l-21.3 40.717a.5.5 0 00.193.662l87.435 50.586a.5.5 0 00.249.067.523.523 0 00.147-.022.5.5 0 00.3-.26l1.079-2.246zm-1.745 1.331l-86.555-50.077 20.831-39.834 1.09.632-19.983 38.029a.5.5 0 00.191.662l85.074 49.24zm-83.513-51.21l19.751-37.579 84.275 46.4L184.3 196.12z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28925"
      d="M126.561 264.823c0-3.2-1.9-6.806-4.317-8.2l-13.488-7.788a3.093 3.093 0 00-3.16-.214 4.092 4.092 0 00-1.655 3.72c0 3.2 1.9 6.8 4.317 8.2l13.489 7.788a3.762 3.762 0 001.867.555 2.55 2.55 0 001.292-.341 4.092 4.092 0 001.655-3.72zm-2.153 2.858a2.12 2.12 0 01-2.164-.215l-13.488-7.787c-2.106-1.216-3.819-4.509-3.819-7.341a3.169 3.169 0 011.157-2.858 2.122 2.122 0 012.164.215l13.489 7.787c2.105 1.216 3.818 4.509 3.818 7.341a3.169 3.169 0 01-1.157 2.858z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28926"
      d="M61.876 221.939l-13.488-7.788a3.094 3.094 0 00-3.161-.214 4.093 4.093 0 00-1.654 3.72c0 3.2 1.9 6.806 4.317 8.2l13.489 7.788a3.761 3.761 0 001.866.555 2.561 2.561 0 001.293-.341 4.092 4.092 0 001.655-3.72c0-3.146-1.936-6.826-4.317-8.2zM64.04 233a2.124 2.124 0 01-2.164-.215L48.388 225c-2.106-1.215-3.819-4.507-3.819-7.34a3.171 3.171 0 011.156-2.858 1.575 1.575 0 01.8-.209 2.781 2.781 0 011.364.423l13.49 7.784c2.1 1.215 3.818 4.508 3.818 7.34A3.169 3.169 0 0164.04 233z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28927"
      d="M241.783 174.825l-8.577 4.951a5.576 5.576 0 00-2.38 4.5 2.37 2.37 0 00.985 2.155 1.575 1.575 0 00.8.211 2.2 2.2 0 001.1-.324l8.576-4.951a5.575 5.575 0 002.381-4.5 2.37 2.37 0 00-.985-2.155 1.848 1.848 0 00-1.9.113zm1.394.75a1.466 1.466 0 01.488 1.292 4.636 4.636 0 01-1.882 3.642l-8.577 4.951a.924.924 0 01-.9.112 1.464 1.464 0 01-.488-1.292 4.636 4.636 0 011.882-3.642l8.576-4.951a1.253 1.253 0 01.6-.19.579.579 0 01.301.078z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28928"
      d="M302.6 141.982a1.848 1.848 0 00-1.893.112l-8.577 4.952a5.572 5.572 0 00-2.38 4.5 2.37 2.37 0 00.985 2.155 1.574 1.574 0 00.8.212 2.212 2.212 0 001.1-.324l8.577-4.952a5.573 5.573 0 002.38-4.5 2.368 2.368 0 00-.992-2.155zm-1.893 5.8l-8.577 4.952a.93.93 0 01-.9.112 1.468 1.468 0 01-.487-1.293 4.632 4.632 0 011.882-3.641l8.577-4.952a1.259 1.259 0 01.6-.189.586.586 0 01.3.077 1.466 1.466 0 01.488 1.292 4.635 4.635 0 01-1.885 3.638z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28929"
      d="M190.162 201.141c.007 0 .025.009 18.438 5.7a6.12 6.12 0 007.658-4.04l.212-.687a8.42 8.42 0 00-5.551-10.52l-2.488-.77 34.683-20.03a.5.5 0 00.249-.431v-30.985a.5.5 0 00-.748-.431l-2.438 1.414-26.448 15.272a11.774 11.774 0 00-4.75 5.124L194.55 190.8c-.133.1-.275.2-.4.311l-.374.33a7.894 7.894 0 00-2.387 3.8l-.392 1.4a2.326 2.326 0 00-2 1.667 2.186 2.186 0 001.165 2.833zm50.514-31.741a.5.5 0 00.249-.431v-27.891l1.442-.836v29.836l-35.232 20.348-1.885-.583zm-30.8-8.208a10.784 10.784 0 014.348-4.693l25.7-14.841v27.023l-35.976 20.765-.83-.257c-.177-.055-.359-.084-.538-.128-.148-.037-.3-.077-.445-.107a10.097 10.097 0 00-.513-.079q-.3-.042-.606-.064c-.14-.009-.279-.021-.419-.024a9.473 9.473 0 00-2.12.186c-.082.017-.163.037-.244.056q-.429.1-.847.238c-.078.026-.157.05-.234.078-.264.1-.522.206-.776.326-.075.034-.153.059-.227.1zm-19.942 37.43a1.312 1.312 0 011.125-.983.767.767 0 01.185.021.49.49 0 00.6-.35l.5-1.794a6.906 6.906 0 012.088-3.325l.373-.329a8.439 8.439 0 018.023-1.722l7.8 2.412a7.416 7.416 0 014.893 9.275l-.212.687a5.137 5.137 0 01-6.409 3.386l-18.42-5.7a1.223 1.223 0 01-.54-1.579z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28930"
      d="M100.128 244.909l-30.871-17.824c-.35-.2-.63-.041-.631.36a1.388 1.388 0 00.627 1.094l30.871 17.823c.349.2.63.035.631-.367a1.375 1.375 0 00-.627-1.086z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28931"
      d="M100.1 253.514l-30.868-17.823c-.349-.2-.63-.035-.631.36a1.389 1.389 0 00.627 1.093l30.872 17.824c.35.2.631.035.632-.367a1.387 1.387 0 00-.632-1.087z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28932"
      d="M100.12 247.78l-30.871-17.824c-.35-.2-.63-.042-.632.36a1.373 1.373 0 00.628 1.086l30.871 17.824c.349.2.63.042.631-.36a1.374 1.374 0 00-.627-1.086z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28933"
      d="M100.112 250.643L69.241 232.82c-.35-.2-.631-.035-.632.367a1.374 1.374 0 00.627 1.086l30.871 17.827c.35.2.631.042.632-.36a1.39 1.39 0 00-.627-1.1z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28934"
      d="M308.233 125.9l-.1-.094-20.561-18.046a3.01 3.01 0 00-.477-.342l-64.489-37.233a46.081 46.081 0 00-41.588-2.275c-.04.017-.079.035-.118.055l-65.832 32.423a2.991 2.991 0 00-1.309 1.263l-15.418 28.605-1.191-1.441a7.869 7.869 0 00-11.208-.895l-.774.674a10.582 10.582 0 00-1.789 13.95l4.111 6.237L43.206 186.3c-3.143 2.648-6.682 7.485-7.487 12.311a3.007 3.007 0 00-.041.492v21.976c0 6.726 2.214 11.709 6.234 14.03l24.863 14.38v5.049a2.989 2.989 0 001.494 2.587l27.205 15.71a2.987 2.987 0 004.481-2.587v-1.57l23.373 13.517a19.586 19.586 0 008.841 2.319h.073a10.068 10.068 0 001.012.048 17.616 17.616 0 009.206-2.893l2.47-1.426 8.98 4.9c.065.035.13.067.2.1a11.429 11.429 0 005.854 1.554 17.493 17.493 0 008.71-2.606c9.3-5.364 16.722-17.514 17.646-28.464a2.86 2.86 0 00.36-.177L252 217.826l9.248 5.343a2.858 2.858 0 00.264.135 11.419 11.419 0 005.852 1.553 17.521 17.521 0 008.711-2.6c9.351-5.4 16.8-17.638 17.668-28.614a2.967 2.967 0 001.036-.561l9.544-7.954a29.674 29.674 0 0010.706-22.858v-20.393a22.3 22.3 0 00-6.8-15.977zm2.487 22.875c-2.358 1.361-4.2 5.531-4.184 9.5.007 2.473.742 4.312 2.016 5.046a2.365 2.365 0 001.192.319 3.037 3.037 0 001.512-.439l.248-.144a26.19 26.19 0 01-9.436 19.6l-8.7 7.252c0-.2-.025-.394-.032-.6-.015-.4-.03-.8-.065-1.184-.029-.319-.075-.624-.117-.932-.038-.275-.074-.552-.123-.818a17.385 17.385 0 00-.231-1.051c-.048-.19-.1-.381-.148-.566a14.286 14.286 0 00-.985-2.513c-.066-.128-.136-.249-.2-.372a11.394 11.394 0 00-.554-.9c-.092-.133-.192-.254-.289-.381-.193-.253-.387-.5-.6-.734-.139-.151-.292-.283-.439-.423-.194-.184-.382-.376-.59-.542-.016-.013-.03-.03-.046-.043a9.137 9.137 0 00-1.016-.691c-.028-.017-.051-.039-.079-.055a9.876 9.876 0 00-.8-.408c-.042-.019-.085-.036-.127-.054a9.077 9.077 0 00-.908-.339l-.1-.035c-2.859-.867-6.24-.411-9.811 1.332-.083.041-.167.081-.25.123-.4.2-.8.411-1.2.643-10.058 5.8-18.241 19.971-18.241 31.578 0 .165 0 .333.011.5l-4.685 2.7-4.668 2.7v-83.831l11.638-6.719 26.821-15.484 20.283 17.8a18.8 18.8 0 015.718 13.463v6.236zm.8 13.119l-.761.439a1.636 1.636 0 01-1.709.12c-.93-.535-1.511-2.139-1.517-4.186-.01-3.519 1.678-7.471 3.686-8.63l.266-.153zm-21.943 22.289l-.062-.114a10 10 0 00-.6-.9c-.05-.068-.1-.137-.152-.2a9.02 9.02 0 00-.638-.734c-.081-.084-.165-.161-.248-.241a8.709 8.709 0 00-.675-.588c-.1-.078-.21-.145-.315-.218-.2-.137-.382-.289-.59-.409-.052-.03-.11-.048-.162-.077l-4.745-2.743.1-.018a11.675 11.675 0 011.384-.086 9.753 9.753 0 012.069.206 8.472 8.472 0 011.079.3c.083.029.161.069.243.1a8.1 8.1 0 01.89.417c.1.056.207.109.307.17a8.213 8.213 0 01.92.64c.182.148.35.317.521.48.143.137.289.269.423.417.184.2.355.421.523.644.1.13.2.258.29.394a9.887 9.887 0 01.686 1.185q.224.444.416.922c.056.137.106.279.157.421.118.323.228.653.324 1 .049.174.089.357.132.537.079.328.156.656.217 1 .046.27.078.554.113.834s.079.547.1.833c.048.578.075 1.173.077 1.789l-1.184-.688c-.023-.2-.064-.393-.094-.592a13.385 13.385 0 00-1.512-4.685zm.744 7.544c0 10.177-7.181 22.607-16.009 27.708-4.179 2.409-8.082 2.814-10.989 1.133-.208-.12-.393-.27-.587-.409a7.094 7.094 0 01-.611-.475c-.1-.089-.192-.19-.289-.285a7.986 7.986 0 01-.58-.622c-.072-.089-.137-.188-.206-.281a8.986 8.986 0 01-.532-.776c-.052-.089-.1-.186-.146-.277a10.094 10.094 0 01-.459-.919c-.041-.1-.073-.2-.112-.3-.131-.33-.257-.666-.362-1.023-.037-.129-.064-.271-.1-.4a14.013 14.013 0 01-.244-1.045c-.039-.219-.061-.454-.092-.681-.041-.3-.09-.584-.117-.892a19.928 19.928 0 01-.072-1.7 27.537 27.537 0 011.259-7.911c2.431-8.03 8.121-15.971 14.736-19.784.485-.279.965-.527 1.441-.752l.149-.071c.478-.221.952-.417 1.419-.583l.067-.023a12.808 12.808 0 012.826-.663h.014a9.919 9.919 0 011.3-.054c.051 0 .1.007.15.009a8.4 8.4 0 011.076.111c.072.012.143.025.214.039a7.781 7.781 0 011.016.271c.042.014.084.026.126.041a7.314 7.314 0 011.085.494.315.315 0 00.052.017c.016.009.033.015.049.024 2.921 1.664 4.527 5.252 4.527 10.075zM178.8 242.665l-4.515-2.609a10.814 10.814 0 011.628-.011q.419.029.823.092.3.048.6.116c.275.063.547.136.812.225.125.041.251.08.374.127a8.192 8.192 0 011 .469c.1.056.2.117.3.177a8.171 8.171 0 01.934.652c.173.143.329.311.491.469s.3.279.441.433c.185.207.353.435.522.663.094.126.191.248.28.38.171.257.329.531.481.811.067.123.135.246.2.373q.219.444.407.922c.055.137.106.278.157.419.113.319.219.646.313.984.049.178.09.363.134.547.075.319.149.64.208.974.047.277.08.566.116.853.033.265.074.524.1.8.047.572.074 1.161.075 1.769l-.865-.5c-.398-4.308-2.172-7.543-5.016-9.135zm4.1 10.991c0 10.19-7.178 22.62-16 27.708-4.177 2.412-8.076 2.816-10.986 1.136-.2-.118-.385-.266-.576-.4a7.37 7.37 0 01-.621-.482c-.1-.09-.2-.192-.294-.289a7.94 7.94 0 01-.573-.612c-.078-.1-.147-.2-.222-.3a8.8 8.8 0 01-.516-.751c-.06-.1-.11-.21-.167-.313a10.167 10.167 0 01-.44-.88c-.048-.112-.085-.234-.13-.348a12.064 12.064 0 01-.346-.977c-.042-.145-.072-.3-.111-.453-.084-.326-.169-.651-.232-1-.043-.233-.066-.481-.1-.722-.038-.283-.086-.559-.111-.853a19.921 19.921 0 01-.073-1.7 26.087 26.087 0 01.72-5.9 33.6 33.6 0 011.213-4.011c2.712-7.324 8-14.3 14.062-17.8.481-.276.957-.52 1.429-.744l.177-.084q.7-.324 1.39-.569c.038-.014.076-.026.115-.039a12.809 12.809 0 012.77-.647l.064-.008a10.042 10.042 0 011.264-.051c.072 0 .142.009.213.013a8.514 8.514 0 011.008.1c.09.015.18.032.269.05a7.682 7.682 0 01.934.249c.07.023.141.044.21.069a7.342 7.342 0 011.057.481 7.214 7.214 0 01.688.458c.091.066.187.123.275.192a7.506 7.506 0 01.66.6c.059.059.122.115.179.176a8.24 8.24 0 01.631.774c.031.043.063.084.094.128a9.357 9.357 0 01.576.943l.041.077a10.745 10.745 0 01.5 1.1l.014.037a14.666 14.666 0 01.878 4.114v.015c.047.493.074.992.074 1.513zm1.726-7.714c-.052-.14-.1-.279-.16-.416-.142-.355-.294-.7-.46-1.029-.061-.12-.128-.235-.192-.352a11.457 11.457 0 00-.556-.926c-.082-.121-.174-.23-.26-.346-.2-.268-.4-.537-.619-.78-.131-.145-.278-.269-.416-.4a9.216 9.216 0 00-.7-.641 9.058 9.058 0 00-.961-.667c-.052-.032-.1-.074-.15-.1a9.205 9.205 0 00-1.61-.728l-.081-.026c-2.883-.966-6.32-.56-9.958 1.187l-.249.122c-.428.212-.858.437-1.29.686l-.028.015c-10.048 5.809-18.222 19.975-18.222 31.578v.5l-8.533 4.924c-3.869 2.232-6.44 2.2-7.268 2.11v-23.69a18.615 18.615 0 01.359-3.594.515.515 0 00.036-.109 18.682 18.682 0 016.223-10.449l45.975-38.738a.544.544 0 00.169-.3l23.646-48.973 36.992-21.356v83.823l-60.641 35.017c0-.12-.015-.229-.017-.348a22.535 22.535 0 00-.071-1.537c-.026-.308-.072-.6-.11-.9s-.073-.581-.123-.861a16.54 16.54 0 00-.227-1.052c-.046-.191-.091-.382-.143-.567-.1-.369-.221-.727-.348-1.077zM91.079 129.667a2.933 2.933 0 01.35.014 4.346 4.346 0 013.013 1.549l3.805 4.6-6.87 12.747-5.142-7.807a7.1 7.1 0 011.2-9.354l.774-.674a4.349 4.349 0 012.87-1.075zm8.2 6.343l17.283-32.065 91.719 50.711-18.452 38.23-4.874 10.1-92.867-53.627zm-7.809 14.145l41.081 23.719 51.749 29.877-45.449 38.294a19.679 19.679 0 00-6.406 10.344L39.27 199.38a15.136 15.136 0 015.285-9.7zm117.459 3.719l-91.491-50.586L182.4 71.3a42.745 42.745 0 0138.443 2.1l63.741 36.8zm-164.22 78.517a11.166 11.166 0 01-5.568-9.643v-21.434q0-.412.026-.845l93.056 52.941a19.564 19.564 0 00-.343 3.623v23.581a15.571 15.571 0 01-7.256-2.077zm25.053 22.145v-6.528l27.206 15.71v6.528z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28935"
      d="M178.608 184.86l-2.887 2.825-.721-.4.808-3.978.689.382-.523 2.333c-.032.136-.077.3-.13.471l-.027.1-.043.14.06-.08c.11-.123.247-.283.419-.474l1.673-1.7.682.379m-1.5 3.6l1.847-3.4.676.375-1.847 3.4-.676-.374m3.823.93l.036-.082c.182-.381.32-.652.406-.81l.877-1.614.611.339-1.848 3.4-.838-.464.062-3.244-.037.086c-.19.4-.331.688-.425.861l-.868 1.6-.611-.338 1.847-3.4.839.465-.052 3.208m3.018-3.828l-7.012-3.887c-1.565-.868-3.677-.03-4.708 1.867s-.6 4.147.971 5.015l7.011 3.887c1.566.868 3.678.03 4.708-1.867s.6-4.147-.97-5.015"
      fill="#fff"
    />
    <path
      data-name="Path 28936"
      d="M178.608 184.86l-.682-.379-1.673 1.7c-.172.191-.309.351-.419.474l-.06.08.043-.14.027-.1c.053-.175.1-.335.13-.471l.523-2.333-.689-.382-.808 3.976.721.4 2.887-2.825"
      fill="#1d1d1b"
    />
    <path data-name="Path 28937" d="M179.635 185.429l-.676-.375-1.847 3.4.676.374 1.847-3.4" fill="#1d1d1b" />
    <path
      data-name="Path 28938"
      d="M182.865 187.219l-.611-.339-.877 1.614c-.086.158-.224.429-.406.81l-.036.082.052-3.208-.839-.465-1.847 3.4.611.338.868-1.6c.094-.173.235-.464.425-.861l.036-.082-.062 3.244.838.464 1.848-3.4"
      fill="#1d1d1b"
    />
    <path data-name="Path 28939" d="M70.26 254.248l26.211 15.135v-12.1L70.26 242.155z" fill="#fff" />
    <path
      data-name="Path 28940"
      d="M97.217 256.569l-27.206-15.708a.5.5 0 00-.746.431v13.244a.5.5 0 00.248.431l27.207 15.71a.5.5 0 00.746-.431V257a.5.5 0 00-.249-.431zm-.746 12.814L70.26 254.248v-12.093l26.211 15.132z"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28941"
      d="M74.417 251.6l.414-3.143.019.011.4 3.614-.834-.482m1.1-3.938l-1.264-.73-.988 6.269.866.5.171-1.238 1.065.615v-.022l.163 1.453.931.537-.944-7.384"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28942"
      d="M77.847 254.872l.006-2.1.417.241a1.151 1.151 0 01.461.451 1.576 1.576 0 01.139.731v.59c0 .25-.04.4-.124.453s-.2.04-.366-.057l-.532-.307m.008-3.075v-1.806l.449.259a.867.867 0 01.359.377 1.343 1.343 0 01.114.6v.376c0 .258-.046.424-.142.471-.091.067-.232.037-.418-.071l-.366-.211m.483-2.506l-1.4-.811-.02 6.828 1.463.845c.469.27.816.33 1.06.2s.362-.471.363-1v-.582a2.424 2.424 0 00-.689-1.824v-.022a.426.426 0 00.45-.22 1.451 1.451 0 00.157-.766v-.273a2.506 2.506 0 00-1.382-2.371"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28943"
      d="M82.6 251.751l-.629-.363a.756.756 0 01-.252.379.47.47 0 01-.392.032 2.757 2.757 0 01-.635-.293v.767l.976.563-.015 5.206.93.537.02-6.828"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28944"
      d="M85.128 253.115c-.45-.259-.8-.312-1.035-.154s-.361.515-.363 1.068v.664l.886.511v-.737c0-.443.162-.579.483-.393a.892.892 0 01.359.377 1.542 1.542 0 01.127.686 1.648 1.648 0 01-.2.822 2.351 2.351 0 01-.722.668 1.9 1.9 0 00-.735.728 2.628 2.628 0 00-.209 1.135v.745l2.7 1.56v-.973l-1.777-1.022v-.147a1.1 1.1 0 01.149-.593 1.792 1.792 0 01.561-.5 2.672 2.672 0 00.9-.845 2.1 2.1 0 00.26-1.069 2.967 2.967 0 00-.356-1.483 2.652 2.652 0 00-1.031-1.039"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28945"
      d="M88.471 255.045c-.443-.255-.777-.3-1.015-.15a1.241 1.241 0 00-.357 1.057v.362l.886.511v-.45c0-.42.149-.549.451-.375a.892.892 0 01.339.366 1.235 1.235 0 01.127.59v.494c0 .259-.053.421-.143.472s-.238.032-.424-.075l-.34-.2v.973l.315.182a1.146 1.146 0 01.468.469 1.68 1.68 0 01.145.756v.553c0 .288-.046.461-.13.531s-.2.055-.36-.038a1.007 1.007 0 01-.48-.949v-.6l-.885-.511v.553a3.033 3.033 0 00.35 1.465 2.7 2.7 0 001.038 1.035c.462.267.809.32 1.041.165s.355-.5.356-1.049v-.6a2.816 2.816 0 00-.158-.985 2.189 2.189 0 00-.525-.812v-.023a.476.476 0 00.5-.19 1.493 1.493 0 00.163-.8v-.244a2.977 2.977 0 00-.343-1.453 2.588 2.588 0 00-1.019-1.025"
      fill="#1d1d1b"
    />
    <path
      data-name="Path 28946"
      d="M91.159 261.317l.925-2.132.013.007-.008 2.662-.93-.537m1.88-3.538l-1.02-.589-1.707 3.638v.973l1.778 1.027v1.238l.937.541v-1.239l.442.256v-.973l-.443-.256.013-4.616"
      fill="#1d1d1b"
    />
  </svg>
)
export { Vehicle }
